import React, { useState } from "react";

import { DateRange } from "react-date-range";
import { addDays, format, isWeekend, addYears } from "date-fns";

import "./style.scss";
export default function DateRangePicker({ dateRange, onChangeDateRange }) {
  const [state, setState] = useState();

  return (
    <div className="date-range-picker-container-field">
      <DateRange
        editableDateInputs={false}
        // onChange={(item) => setState([item.selection])}
        onChange={onChangeDateRange}
        moveRangeOnFirstSelection={false}
        ranges={dateRange}
        color={"black"}
        rangeColors={["#e2136e"]}
        maxDate={new Date()}
      />
    </div>
  );
}
